import { useState } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { useLanguage } from "src/hooks/UseLanguage";
import LanguageSwitcher from "src/components/common/LanguageSwitcher";
import { resendResetPasswordEmail } from "src/services/AuthenticationAPIs";

export default function Resetpassword() {
  const [, setResendStatus] = useState("");
  const { t } = useTranslation();
  useLanguage(); // Initialize RTL support

  const handleResend = async () => {
    try {
      const result = await resendResetPasswordEmail();

      if (result.status) {
        message.success(t("resetPasswordNotification.resendSuccess"));
      } else {
        message.error(
          result.message || t("resetPasswordNotification.resendFailed")
        );
      }
    } catch {
      message.error(t("resetPasswordNotification.resendError"));
    } finally {
      setResendStatus("");
    }
  };

  return (
    <>
      <div
        className="reset-pass-bg"
        style={{ backgroundImage: "url(/Icons/forget-password-bg.svg)" }}
      >
        <div className="logo-wrapper">
          <img src="/images/DpLogo.png" className="logo-design" alt="img" />
          <LanguageSwitcher />
        </div>
        <div className="app">
          <div className="signup-internal-container">
            <form className="formdesign">
              <img
                src="/images/envelopeopentext.png"
                className="user-lock"
                alt="envelopeopentext"
              />
              <h2 className="Reset-password">
                {t("resetPasswordNotification.followTheLink")}
              </h2>
              <p className="email-sent-detail ">
                {t("resetPasswordNotification.resetLinkSent")}
              </p>

              <br />
              <br />
              <br />

              <p className="signup-page-text">
                {t("resetPasswordNotification.didNotReceive")}&nbsp;
                <button
                  className="resend-button button"
                  onClick={handleResend}
                  type="button"
                >
                  {t("resetPasswordNotification.resend")}
                </button>
              </p>

              <div className="signup-page-text">
                {t("resetPasswordNotification.rememberPassword")}&nbsp;
                <a href="/log-in">{t("resetPasswordNotification.signIn")}</a>
              </div>

              <br />
              <br />
              <br />
              <br />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
